export default function InvalidRequestError(payload, message) {
  this.name = 'BadRequestError';
  this.message = message;
  this.error = payload; // Legacy
  this.errors = payload;
  this.stack = (new Error()).stack;
}
InvalidRequestError.prototype = new Error();
